import axios from "axios";
import { BaseURL } from "./endpoints";
import { store } from "shared/redux/store";
import { resetAuth } from "shared/redux/reducers/authSlice";

export const HTTP_CLIENT = axios.create({
  baseURL: BaseURL,
  timeout: 30000,
});

const setupAxios = () => {
  HTTP_CLIENT.interceptors.request.use(
    (config: any) => {
      const accessToken = store.getState().root.auth?.accessToken;
      if (accessToken) {
        config.headers["authorization"] = `Bearer ${accessToken}`;
      }

      return config;
    },
    (err: any) => Promise.reject(err)
  );
};

HTTP_CLIENT.interceptors.response.use(
  (response: any) => {
    return response;
  },
  (err: any) => {
    if (err?.response?.status === 401) {
      const { auth } = store.getState().root;
      if (auth?.accessToken) {
        store.dispatch(resetAuth());
        window.location.reload();
      }
    }
    return Promise.reject(err);
  }
);

export const initialConfig = () => {
  setupAxios();
};

initialConfig();
